import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedDate } from 'react-intl';
import { getCollabColorValue } from 'constants/collabColors';
import styled from 'styled-components';

const CompletedByIcon = styled.i`
  margin-right: var(--cc_size_spacing_xs);
`;

const CompletedByText = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-family: 'Averta', system-ui, sans-serif;
  font-size: var(--cc_size_text_xs);
  color: var(--cc_color_text_nonessential);
`;

const Icon = styled.i`
  color: ${({ color }) => getCollabColorValue(color)};
  margin-inline-end: var(--cc_size_spacing_xxs);
  font-size: ${(props) =>
    props.isOwner ? 'var(--cc_size_text_xs)' : 'var(--cc_size_text_xxs)'};
`;

const CompletedByCompanyName = styled.span`
  white-space: nowrap;
`;

const CompletedByInfo = ({
  completed,
  completedByUserName,
  completedAt,
  completedByCompany,
}) => {
  const companyNodeId = useSelector(({ company }) => company.node_id);

  if (completed && completedByUserName && completedAt) {
    return (
      <CompletedByText>
        <CompletedByIcon className="mdi mdi-account-check" />
        {completedByUserName}, &nbsp;
        {completedByCompany && completedByCompany?.id !== companyNodeId ? (
          <CompletedByCompanyName>
            <Icon
              className={
                completedByCompany.accentColor === 'owner'
                  ? 'mdi mdi-crown'
                  : 'mdi mdi-domain'
              }
              color={completedByCompany.accentColor}
              isOwner={completedByCompany.accentColor === 'owner'}
            />
            {completedByCompany.name}, &nbsp;
          </CompletedByCompanyName>
        ) : null}
        <FormattedDate
          value={completedAt}
          month="numeric"
          day="numeric"
          year="numeric"
          hour="numeric"
          minute="numeric"
        />
      </CompletedByText>
    );
  }
  return null;
};

CompletedByInfo.propTypes = {
  completed: PropTypes.bool,
  completedByUserName: PropTypes.string,
  completedAt: PropTypes.string,
  completedByCompany: PropTypes.object,
};

export default CompletedByInfo;
